import { render, staticRenderFns } from "./ManageBrands.vue?vue&type=template&id=4dc26fa1&scoped=true&"
import script from "./ManageBrands.vue?vue&type=script&lang=js&"
export * from "./ManageBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc26fa1",
  null
  
)

export default component.exports